module.exports = __webpack_public_path__ + "static/media/mobileScreenshot01.1275b4c5.jpg";